
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ISigmaRing } from "@/interfaces/mlm";
import { dispAuthFetch, dispatchGetSigmaRings, dispatchGetUserSigmaRings } from "@/store/mlm/actions";

@Component({
  components: {
  },
})
export default class RingsEditOrderModal extends Vue {
  @Prop({ required: true, default: false }) public readonly modalShow!: boolean;
  @Prop({ required: true }) public readonly orderData!: any;

  public isModalClosed: boolean = false;
  public loadingState: boolean = false;

  sigma_rings_without_size_kit: ISigmaRing[] = [];
  sigma_rings_size_kit: ISigmaRing[] = [];
  sigma_rings: ISigmaRing[] = [];
  selectedSizeId: number | null = null;
  selectedRingProductToChange: ISigmaRing | null = null;

  public countryList = [
    { value: "CA", label: "Canada" },
    { value: "GB", label: "United Kingdom" },
    { value: "DE", label: "Germany" },
    { value: "FR", label: "France" },
    { value: "IT", label: "Italy" },
    { value: "ES", label: "Spain" },
    { value: "AT", label: "Austria" },
    { value: "SK", label: "Slovakia" },
    { value: "SI", label: "Slovenia" },
    { value: "RO", label: "Romania" },
    { value: "BG", label: "Bulgaria" },
    { value: "PL", label: "Poland" },
    { value: "CH", label: "Switzerland" },
    { value: "SE", label: "Sweden" },
    { value: "DK", label: "Denmark" },
    { value: "FI", label: "Finland" },
    { value: "NL", label: "Netherlands" },
    { value: "LU", label: "Luxembourg" },
    { value: "BE", label: "Belgium" },
    { value: "CZ", label: "Czech Republic" },
    { value: "GR", label: "Greece" },
    { value: "LT", label: "Lithuania" },
    { value: "EE", label: "Estonia" },
    { value: "LV", label: "Latvia" },
    { value: "IE", label: "Ireland" },
    { value: "PT", label: "Portugal" },
    { value: "NO", label: "Norway" },
    { value: "RU", label: "Russian Federation" },
    { value: "BY", label: "Belarus" },
    { value: "KZ", label: "Kazakhstan" },
    { value: "UA", label: "Ukraine" },
    { value: "AE", label: "UAE (Dubai)" },
  ];

  public deliveryAddress: any = {
    country: "",
    city: "",
    street: "",
    house: "",
    apartment: "",
    postalCode: "",
  };

  @Watch("orderData", { immediate: true, deep: true })
  public onOrderDataChange() {
    if (this.orderData && this.orderData.delivery_address) {
      this.deliveryAddress = {
        country: this.normalizeCountry(this.orderData.delivery_address.country),
        city: this.orderData.delivery_address.city || "",
        street: this.orderData.delivery_address.street || "",
        house: this.orderData.delivery_address.house || "",
        apartment: this.orderData.delivery_address.apartment || "",
        postalCode: this.orderData.delivery_address.postal_code || "",
      };
    }
  }

  @Watch("modalShow", { immediate: false })
  public async onModalShowChange(newVal: boolean) {
    if (newVal && this.orderData) {
      // Инициализируем данные при открытии модального окна
      await this.initializeSelectedProduct();
    }
  }

  get sigmaRings() {
    return this.$store.getters.sigmaRings;
  }

  public async mounted() {
    const storeRings = this.sigmaRings;
    if (storeRings && storeRings.length > 0) {
      this.sigma_rings = storeRings;
    } else {
      // Если данных нет или массив пустой, загружаем через API
      this.sigma_rings = await dispatchGetSigmaRings(this.$store) || [];
    }

    this.sigma_rings_size_kit = this.sigma_rings.filter((ring) => ring.name.toLowerCase().includes("size kit"));
    this.sigma_rings_without_size_kit = this.sigma_rings.filter(
      (ring) => !ring.name.toLowerCase().includes("size kit")
    );
    this.sigma_rings_without_size_kit.sort((a, b) => a.bitrix_product_id - b.bitrix_product_id);

    this.onOrderDataChange();
    
    // Инициализируем выбранный продукт только если orderData уже есть
    if (this.orderData) {
      await this.initializeSelectedProduct();
    }
  }

  private async initializeSelectedProduct() {
    if (!this.orderData || !this.orderData.product_name) {
      // console.log('orderData or product_name is missing');
      return;
    }
    // поиск по имени
    const foundRingByName = this.sigma_rings.find((ring) => ring.name === this.orderData.product_name);
    if(foundRingByName) {
      this.selectedSizeId = foundRingByName.id;
      this.selectedRingProductToChange = foundRingByName;
      return;
    }
   
    
    // console.log('selectedSizeId', this.selectedSizeId);
    // console.log('selectedRingProduct', this.selectedRingProduct);
  }

  private normalizeCountry(countryValue: string): string {
    if (!countryValue) return "";

    // Check if it's a country code (e.g., 'CA', 'GB')
    const countryByCode = this.countryList.find((c) => c.value === countryValue);
    if (countryByCode) {
      return countryByCode.label;
    }

    // Check if it's already a label (e.g., 'Canada', 'United Kingdom')
    const countryByLabel = this.countryList.find((c) => c.label === countryValue);
    if (countryByLabel) {
      return countryByLabel.label;
    }

    // Try to find by translated label (case-insensitive partial match)
    const normalizedValue = countryValue.toLowerCase().trim();
    for (const country of this.countryList) {
      const translatedLabel = this.$t(country.label).toString().toLowerCase();
      if (translatedLabel === normalizedValue || country.label.toLowerCase() === normalizedValue) {
        return country.label;
      }
    }

    return countryValue;
  }

  // Methods
  public async handleChangeOrderData() {
    /**
     * sigma_ring_id - это id продукта, то есть размера
     */
    // Validate form before submission
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      return;
    }



    // Prepare data for API
    // Note: country is stored as label (e.g., 'Canada'), but API might expect code or label
    // Adjust based on your API requirements

    const responseChangeOrderData = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/sigma_ring/change/",
      init: {
        method: "POST",
        body: {
          user_sigma_ring_id: this.orderData.id,
          country: this.deliveryAddress.country, // or convert to code if needed
          city: this.deliveryAddress.city,
          street: this.deliveryAddress.street,
          house: this.deliveryAddress.house,
          apartment: this.deliveryAddress.apartment || "",
          postal_code: this.deliveryAddress.postalCode,
          sigma_ring_id: this.selectedRingProductToChange ? this.selectedRingProductToChange.id : null
        },
      }
    });

    if (responseChangeOrderData && responseChangeOrderData.status === 200) {
      this.$toast.success(this.$t('Saved successfully').toString());
      
    } else if(responseChangeOrderData && responseChangeOrderData.status === 400) {
      this.$toast.error(this.$t("Something went wrong, try again later").toString());
    }

    await this.handleUpdateOrders();
    this.closeModal();
  }

  // public async loadSigmaRingsList() {
  //   const sigmaRingsResp = await dispAuthFetch(this.$store, {
  //     input: "/api/v1/mlm/sigma_rings/",
  //     init: {
  //       method: "GET",
  //     },
  //   });

  //   if (sigmaRingsResp.status === 200) {
  //     const sigmaRingsResponse = await sigmaRingsResp.json();
  //     return sigmaRingsResponse;
  //   } else {
  //     this.$toast.error("Failed to get sigma rings, please try again later", {
  //       message: "Failed to get sigma rings, please try again later",
  //       duration: 3000,
  //       position: "bottom",
  //     });
  //     return null;
  //   }
  // }

  public async handleUpdateOrders() {
    this.loadingState = true;
    // console.log('update orders');
    await dispatchGetUserSigmaRings(this.$store);
    this.loadingState = false;
  }

  // Метод для извлечения размера из имени продукта
  extractSizeFromName(name: string): number {
    const match = name.match(/Size:\s*(\d+)/i);
    return match ? parseInt(match[1], 10) : 6; // По умолчанию размер 6
  }

  selectRingProductToChange(product: ISigmaRing): void {
    this.selectedSizeId = product.id;
    this.selectedRingProductToChange = product;
  }

  public closeModal() {
    this.isModalClosed = true;
    this.$emit("close-modal");
  }
}
